// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"_3MWj50dVHKukmXkUm9EynM"};